import script from "./ManageProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageProduct.vue?vue&type=script&setup=true&lang=js"

import "./ManageProduct.vue?vue&type=style&index=0&id=5832ab48&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5832ab48"]])

export default __exports__